import Plyr from "plyr";
import sharer from "sharer.js";
import Sticky from "sticky-js";
import Swiper from "Swiper";
import Isotope from "isotope-layout";
import GLightbox from "glightbox";
import Cookies from "js-cookie";

jQuery(document).ready(function($) {
  // document.querySelector('#add-to-calendar-1').appendChild(myCalendar);

  $(".add-calendar").each(function() {
    var $title = $(this).attr("data-title"),
      $start = $(this).attr("data-start"),
      $end = $(this).attr("data-end");

    var myCalendar = createCalendar({
      data: {
        title: $title,
        start: new Date($start),
        duration: 100,
        end: new Date($end),
        address: "How to Web",
      },
    });

    $(this).append(myCalendar);
  });

  const players = Array.from(document.querySelectorAll(".js-player")).map(
    (p) => new Plyr(p)
  );
  const player = new Plyr("#liveplayer", {
    autoplay: true,
    muted: true,
    hideControls: true,
    loop: true,
  });

  const lightbox = GLightbox();

  $('a[href*="#workshop-news"], .dialog__close').on("click", function(e) {
    e.preventDefault();
    $(".dialog--newsletter").fadeToggle();
  });

  $(".wpcf7-list-item-label").html(function(i, html) {
    return html.replace(/(\w+\s\w+)/, "<strong>$1</strong>");
  });

  document.addEventListener(
    "wpcf7submit",
    function(event) {
      if ("4635" == event.detail.contactFormId) {
        setTimeout(function() {
          $(".dialog--newsletter").fadeOut();
        }, 1000);
      }
    },
    false
  );

  var sticky = new Sticky(".rc-events__side");
  var sticky2 = new Sticky(".summary");

  var review = new Swiper(".reviews__slider", {
    speed: 400,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  var explore = new Swiper(".explore_slider", {
    speed: 400,
    slidesPerView: "auto",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        spaceBetween: 70,
      },
    },
  });

  var solutions__slider = new Swiper(".solutions__slider", {
    speed: 400,
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });

  var comps = new Swiper(".logo__list2", {
    speed: 400,
    loop: true,
    slidesPerView: 2,
    autoplay: true,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      600: {
        slidesPerView: 6,
        spaceBetween: 40,
      },
      992: {
        slidesPerView: 7,
        spaceBetween: 50,
      },
    },
  });

  var comps2 = new Swiper(".logo__list", {
    speed: 400,
    loop: true,
    slidesPerView: 2,
    autoplay: true,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      600: {
        slidesPerView: 6,
        spaceBetween: 40,
      },
      992: {
        slidesPerView: 7,
        spaceBetween: 50,
      },
    },
  });

  var solutions = document.querySelector(".solutions__tab");
  if (solutions) {
    var solutions_iso = new Isotope(solutions, {
      itemSelector: ".solution",
    });
  }

  $(".solutions__nav").on("click", "button", function() {
    $(this)
      .addClass("active")
      .siblings()
      .removeClass("active");
    var filterValue = $(this).attr("data-filter");
    solutions_iso.arrange({ filter: filterValue });
  });

  var agenda = document.querySelector(".rcon-agenda__tab");
  if (agenda) {
    var agenda_iso = new Isotope(agenda, {
      itemSelector: ".rcon-agenda__event",
      filter: ".agenda_day-jun-30",
    });
  }

  $(".rcon-agenda__nav").on("click", "button", function() {
    $(this)
      .addClass("active")
      .siblings()
      .removeClass("active");
    var filterValue = $(this).attr("data-filter");
    agenda_iso.arrange({ filter: filterValue });
  });

  $(".rcon-agenda__event").on("click", function(e) {
    $(this)
      .toggleClass("active")
      .siblings()
      .removeClass("active");
    agenda_iso.layout();
  });

  $(".time-zone span").on("click", function(e) {
    e.preventDefault();
    $(this)
      .addClass("active")
      .siblings()
      .removeClass("active");
    var tz = $(this).attr("id");
    $(".calendar-time").each(function() {
      $(this).text($(this).attr("data-" + tz));
    });
  });

  /* Function to animate height: auto */
  function autoHeightAnimate(element, time) {
    var curHeight = element.height(), // Get Default Height
      autoHeight = element.css("height", "auto").height(); // Get Auto Height
    element.height(curHeight); // Reset to Default Height
    element.stop().animate({ height: autoHeight }, time); // Animate to Auto Height
  }

  $(".sassy-toggle").on("click", function() {
    var parent = $(this).parents(".sassy__section");
    var content = $(parent).find(".sassy__content");
    var scrollTarget = $(this).offset().top;

    if ($(parent).hasClass("is-open")) {
      content.stop().animate({ height: 300 }, 300);
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: scrollTarget,
        },
        100
      );
    } else {
      autoHeightAnimate(content, 300);
    }

    $(parent).toggleClass("is-open");
  });

  var hero = $(".section-hero").height();

  $(window).scroll(function() {
    if ($(window).scrollTop() > 100) {
      $(".spotlight-header").addClass("isVisible");
    } else {
      $(".spotlight-header").removeClass("isVisible");
    }

    if ($(window).scrollTop() > hero) {
      $(".spotlight-btn").addClass("isVisible");
    } else {
      $(".spotlight-btn").removeClass("isVisible");
    }

    if ($(window).scrollTop() > 10) {
      $(".cheader").addClass("sticky");
    } else {
      $(".cheader").removeClass("sticky");
    }
  });

  $(".benefits__toggle").on("click", function() {
    $(this).toggleClass("active");
    $(".benefits-col-9, .benefits-col-8, .benefits-col-7").slideToggle();
  });

  $(".see span, .spotlight__details__close").on("click", function() {
    $(".spotlight__details").fadeToggle();
  });

  $(".person-list__more span").on("click", function() {
    var section = $(this).parents(".section-speakers-list");
    section.find(".all-topics").show();
    $(this).fadeOut();
  });

  $(".section-speakers-list .filter-list > li > span").on("click", function(e) {
    var section = $(this).parents(".section-speakers-list");
    section.find(".person-list__more span").hide();
    if ($(this).hasClass("all-topics")) {
      section.find(".filter-list li").removeClass("active");
    }
  });

  $(document).on("click", 'a[href^="#"]', function(event) {
    event.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $($.attr(this, "href")).offset().top - 100,
      },
      300
    );
  });

  // show mobile menu
  $(".cheader").on("click", ".mobile-nav-toggle", function(e) {
    $(".mobile-nav-toggle").toggleClass("mobile-nav-open");
    $(".cheader").toggleClass("show-menu");
  });

  if ($(window).width() > 768) {
    $(".con__speaker").hover(function() {
      $(this)
        .find(".con__speaker__text")
        .slideToggle(200);
    });
  }

  if (Cookies.get("banner") != "show") {
    setTimeout(function() {
      $("body").addClass("show-august");
      $("#august").slideDown();
    }, 2000);
  }
  $(".countdown__close").on("click", function() {
    $("body").removeClass("show-august");
    $("#august").slideUp();
    Cookies.set("banner", "show", { expires: 0.1 });
  });

  $(".pre-content--toogle").on("click", function() {
    console.log("test");
    $(this)
      .parents(".pre-content")
      .toggleClass("show-more");
  });
});
